import { identifyUser } from '../utils/analytics';
import { getAuthToken } from '../api/auth';

export function initializeAuth(username: string | null) {
  const token = getAuthToken();
  const isAuthenticated = !!token;
  
  // Always identify if we have a valid username
  if (isAuthenticated && username) {
    identifyUser(username);
  }
  
  return { isAuthenticated, token, username };
}

export function handleLogin(token: string, username: string) {
  // Always identify on login
  identifyUser(username);
  return { isAuthenticated: true, token, username };
}